import { FlexWrap } from "../../../../../base/styles";
import clsx from "clsx";

export const SelectWrap = ({ title, value, className, onChange }:{
    title: string,
    value?: FlexWrap,
    className?: string,
    onChange: (value?: FlexWrap) => void,
}) => {
    const handleOnSelectionChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const newValue = e.target.value as FlexWrap;
        newValue ? onChange(newValue) : onChange(undefined);
    }

    return (
        <div className={clsx(className, "field-group")}>
            <label className="fs-8 fw-bold text-gray-600">{title}</label>
            <select
                onChange={handleOnSelectionChange}
                value={value || ""}
                className="form-select form-select-sm form-control-xs">
                <option></option>
                <option value={FlexWrap.NoWrap}>No Wrap</option>
                <option value={FlexWrap.Wrap}>Wrap</option>
                <option value={FlexWrap.WrapReverse}>Wrap Reverse</option>
            </select>
        </div>
    )
}